import { render, staticRenderFns } from "./CurrentSetting.vue?vue&type=template&id=5138a4fe&scoped=true&"
import script from "./CurrentSetting.vue?vue&type=script&lang=js&"
export * from "./CurrentSetting.vue?vue&type=script&lang=js&"
import style0 from "./CurrentSetting.vue?vue&type=style&index=0&id=5138a4fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5138a4fe",
  null
  
)

export default component.exports